// extracted by mini-css-extract-plugin
module.exports = {"line":"InkLine_line__wM6yJ","painted":"InkLine_painted__6iHEv"};